<template>
  <main>
    <div id="app">
      <div id="nav-container">
        <NavBar v-if="isAuthenticated && !$route.meta.hideNavbar" />
      </div>
      <div
        id="main-section"
        class="section"
        :class="{ 'is-denim-bg' : isGradientBackground }"
      >
        <b-container
          id="main-container"
          is-fluid
        >
          <router-view :key="$route.fullPath" />
          <observation-result-basket />
        </b-container>
      </div>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex'
import NavBar from './components/structures/Navbar'
import ObservationResultBasket from './components/agent/ObservationResultBasket'
import api from '@/api'

export default {
  name: 'App',
  components: {
    ObservationResultBasket,
    NavBar,
  },
  created: function () {
    api.interceptors.response.use(
      response => response,
      err => {
        const res = err.response
        if (res.status === 401 && res.config && !res.config.__isRetryRequest) {
          this.$store.dispatch('logout')
            .then(() => {
              this.$router.push({ name: 'login' })
            })
        }
      }
    )
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'hideNavbar']),
    isGradientBackground () {
      return this.$route.name === 'home' || this.$route.name === 'login'
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/colorpallet.scss";

html,
body,
main {
  height: 100%;
  font-family: "Lato", regular;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: $secondary-bg;
}
</style>

<style lang="scss" scoped>
@import "./src/assets/colorpallet.scss";
@import "./src/assets/layout-utils.scss";

$angle: 180deg;

#main-section {
  padding-top: 1.5rem;
  flex: 1;
  align-items: stretch;
  justify-content: center;
  padding-bottom: $result-basket-min-height;
}

.is-denim-bg {
  background-image: linear-gradient($angle, $denim-light, $denim-dark);
}
</style>
